import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    cuentaCorriente: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    fechaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    cliente: null,

    rptCuentaCorriente: [],
    rptDeuda: [],
    rptPlazos: [],

    rptResumenDeuda: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.cuentaCorriente = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.fechaDesde = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.cliente = null;
    },

    'INICIALIZAR_CUENTA_CORRIENTE' (state) {
        state.cuentaCorriente = [];
    },
    'SET_CUENTA_CORRIENTE' (state, cuentaCorriente) {
        state.cuentaCorriente = cuentaCorriente;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_RPT' (state) {
        state.rptCuentaCorriente = [];
    },
    'SET_RPT' (state, rptCuentaCorriente) {
        state.rptCuentaCorriente = rptCuentaCorriente;
    },
    'INICIALIZAR_RPT_DEUDA' (state) {
        state.rptDeuda = [];
    },
    'SET_RPT_DEUDA' (state, rptDeuda) {
        state.rptDeuda = rptDeuda;
    },
    'INICIALIZAR_RPT_PLAZOS' (state) {
        state.rptPlazos = [];
    },
    'SET_RPT_PLAZOS' (state, rptPlazos) {
        state.rptPlazos = rptPlazos;
    },
    'INICIALIZAR_RESUMEN_DEUDA' (state) {
        state.rptResumenDeuda = [];
    },
    'SET_RESUMEN_DEUDA' (state, rptResumenDeuda) {
        state.rptResumenDeuda = rptResumenDeuda;

        let deudaVencidaPesos = rptResumenDeuda.reduce((total, cliente) => {
            return total += cliente.deudaVencidaPesos;
        }, 0)
        let deudaVencerPesos = rptResumenDeuda.reduce((total, cliente) => {
            return total += cliente.deudaVencerPesos;
        }, 0)
        let deudaVencidaDolares = rptResumenDeuda.reduce((total, cliente) => {
            return total += cliente.deudaVencidaDolares;
        }, 0)
        let deudaVencerDolares = rptResumenDeuda.reduce((total, cliente) => {
            return total += cliente.deudaVencerDolares;
        }, 0)

        state.rptResumenDeuda.push({
            clienteId: -1,
            cliente: 'TOTALES',
            deudaVencidaPesos,
            deudaVencerPesos,
            deudaVencidaDolares,
            deudaVencerDolares,
            _rowVariant: 'totales'
        })
    },
};

const getters = {
    getField,

    rptCuentaCorriente(state) {
        return state.rptCuentaCorriente;
    },
    rptDeuda(state) {
        return state.rptDeuda;
    },
    rptPlazos(state) {
        return state.rptPlazos;
    },
    rptResumenDeuda(state) {
        return state.rptResumenDeuda;
    }
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getCuentaCorriente ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CUENTA_CORRIENTE');
            
            let queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');
            
            if (state.paginaActual != 0) {
              queryString += '&pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
            }
            if (state.cliente) {
                if (state.cliente.id != 0) {
                    queryString += '&clienteId=' + state.cliente.id;
                }
            }
            
            apiAxios.get('cuentacorrienteclientes/resumen' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_CUENTA_CORRIENTE', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    getRptCuentaCorriente ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT');
            
            let queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');
            
            if (state.cliente) {
                if (state.cliente.id != 0) {
                    queryString += '&clienteId=' + state.cliente.id;
                }
            }
            
            apiAxios.get('cuentacorrienteclientes/resumen/export' + queryString)
                .then(res => {
                    commit('SET_RPT', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    getRptDeuda ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT_DEUDA');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');
        
            if (params.proveedorId != 0) {
                queryString += '&clienteId=' + params.clienteId;
            }

            apiAxios.get('cuentacorrienteclientes/rpt/deuda' + queryString)
                .then(res => {
                    commit('SET_RPT_DEUDA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    getRptPlazos ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT_PLAZOS');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');
        
            if (params.proveedorId != 0) {
                queryString += '&clienteId=' + params.clienteId;
            }

            if ((/true/i).test(params.incluirReembolsos)) {
                queryString += '&incluirReembolsos=true';
            }

            if ((/true/i).test(params.incluirComprobantesCancelados)) {
                queryString += '&incluirComprobantesCancelados=true';
            }

            apiAxios.get('cuentacorrienteclientes/rpt/plazos' + queryString)
                .then(res => {
                    commit('SET_RPT_PLAZOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    getRptResumenDeuda ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESUMEN_DEUDA');

            apiAxios.get('cuentacorrienteclientes/resumen-deuda')
                .then(res => {
                    commit('SET_RESUMEN_DEUDA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}